import React, { useEffect } from 'react';
import { css } from "@emotion/react";
import { useQuery } from "@apollo/client";

import logo from '../../images/WTB_logo.png'
import { CORPORATE_URL } from "../../config/config";
import { GET_FEATURE_FLAGS } from "../includes/queries";
import { useAppState } from "../contexts/AppContext";

const Header = () => {
    const [,setAppState] = useAppState();
    const { data: featureFlagsData, loading: featureFlagsLoading } = useQuery(GET_FEATURE_FLAGS, {
        context: { clientName: "corporate" }
    });

    useEffect(() => {
        if (featureFlagsData && !featureFlagsLoading) {
            setAppState({
                featureFlags: featureFlagsData.featureFlags,
                isFeatureFlagsLoading: featureFlagsLoading,
            });
        }
    }, [featureFlagsData, featureFlagsLoading, setAppState]);

    return (
        <div css={containerStyle}>
            <a href={CORPORATE_URL} aria-label={"Go to the Writer's Toolbox Home page"}>
                <img src={logo} css={imageStyle} alt={""} />
            </a>
        </div>
    );
}

const containerStyle = css`
    width: 100%;
    height: 87px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 15px #00000029;
    margin-bottom: 20px;
`;

const imageStyle = css`
    height: 28px;
`;

export default Header;
